import { getAllCategories, getAllProducts } from '../../../data/catalog';

const TYPES = [
  { key: 'todos', label: 'Todos os Tecidos' },
  { key: 'categoria', label: 'Categoria' },
  { key: 'tecido', label: 'Tecido' },
  { key: 'loja', label: 'Nossa Loja' },
];

const selCls =
  'h-12 w-full rounded-xl border border-input bg-white px-4 text-sm font-medium outline-none focus:border-navy';

export default function DestinationPicker({ destType, destValue, onChange, testid = 'dest' }) {
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      <div>
        <label htmlFor={`${testid}-type`} className="sr-only">Tipo de destino</label>
        <select
          id={`${testid}-type`}
          data-testid={`${testid}-type`}
          value={destType}
          onChange={(e) => onChange(e.target.value, '')}
          className={selCls}
        >
          {TYPES.map((t) => (
            <option key={t.key} value={t.key}>{t.label}</option>
          ))}
        </select>
      </div>
      {destType === 'categoria' && (
        <div>
          <label htmlFor={`${testid}-value`} className="sr-only">Escolha a categoria</label>
          <select
            id={`${testid}-value`}
            data-testid={`${testid}-value`}
            value={destValue}
            onChange={(e) => onChange(destType, e.target.value)}
            className={selCls}
          >
            <option value="">Escolha a categoria</option>
            {getAllCategories().map((c) => (
              <option key={c.slug} value={c.slug}>{c.name}</option>
            ))}
          </select>
        </div>
      )}
      {destType === 'tecido' && (
        <div>
          <label htmlFor={`${testid}-value`} className="sr-only">Escolha o tecido</label>
          <select
            id={`${testid}-value`}
            data-testid={`${testid}-value`}
            value={destValue}
            onChange={(e) => onChange(destType, e.target.value)}
            className={selCls}
          >
            <option value="">Escolha o tecido</option>
            {getAllProducts().map((p) => (
              <option key={p.slug} value={p.slug}>{p.name}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
